// ── Types ─────────────────────────────────────────────────────────────────────

export interface ClickEventRecord {
  url: string;
  clickedAt: string;
  ipAddress: string;
  userAgent: string;
}

export interface EmailSendRecordItem {
  id: string;
  userId: string;
  userEmail: string;
  userType: string;
  templateKey: string;
  subject: string;
  sentAt: string;
  openCount: number;
  firstOpenAt: string | null;
  lastOpenAt: string | null;
  clickCount: number;
  firstClickAt: string | null;
  enrollmentId: string | null;
  step: number | null;
  clicks: ClickEventRecord[];
  /** BOUNCED | COMPLAINED, or null when SES reported no problem. */
  deliveryStatus?: string | null;
  bouncedAt?: string | null;
  /** Permanent | Transient | Undetermined, or COMPLAINT. */
  bounceType?: string | null;
  bounceReason?: string | null;
}

export interface EmailAuditPage {
  content: EmailSendRecordItem[];
  totalElements: number;
  totalPages: number;
}

export interface EmailAuditFilters {
  page: number;
  size: number;
  periodDays: number;
  userType: string;
  templateKey: string;
  hasOpened: string;   // 'all' | 'true' | 'false'
  hasClicked: string;  // 'all' | 'true' | 'false'
  deliveryStatus: string; // 'all' | 'BOUNCED' | 'COMPLAINED' | 'NONE'
  search: string;
}

// ── Action types ──────────────────────────────────────────────────────────────

export enum ActionTypes {
  FETCH_AUDIT_REQUEST = 'emailAudit/fetchRequest',
  FETCH_AUDIT_SUCCESS = 'emailAudit/fetchSuccess',
  FETCH_AUDIT_FAILURE = 'emailAudit/fetchFailure',
}

export type FetchAuditRequestAction = {
  type: ActionTypes.FETCH_AUDIT_REQUEST;
  payload: EmailAuditFilters;
}
export type FetchAuditSuccessAction = {
  type: ActionTypes.FETCH_AUDIT_SUCCESS;
  payload: EmailAuditPage;
}
export type FetchAuditFailureAction = {
  type: ActionTypes.FETCH_AUDIT_FAILURE;
  payload: string;
}

export type EmailAuditAction =
  | FetchAuditRequestAction
  | FetchAuditSuccessAction
  | FetchAuditFailureAction;

// ── Action creators ───────────────────────────────────────────────────────────

export const fetchAuditRequest = (filters: EmailAuditFilters): FetchAuditRequestAction => ({
  type: ActionTypes.FETCH_AUDIT_REQUEST,
  payload: filters,
});

export const fetchAuditSuccess = (data: EmailAuditPage): FetchAuditSuccessAction => ({
  type: ActionTypes.FETCH_AUDIT_SUCCESS,
  payload: data,
});

export const fetchAuditFailure = (error: string): FetchAuditFailureAction => ({
  type: ActionTypes.FETCH_AUDIT_FAILURE,
  payload: error,
});
